import React, { useState, useEffect }  from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useFormik } from "formik";
import * as Yup from "yup";

import { updateBookingRequest, getRequestStatus } from '../../../../store/Bookings/actions'
import messages from '../../../../assets/locale/messages';
import { POSITIVE_TWO_DICIMAL_ONLY, POSITIVE_NEGATIVE_TWO_DICIMAL_ONLY } from '../../../../utils/Patterns'
import RadioButtonsGroup from '../../../../components/RadioButton'
import Modal from '../../../../components/Modal'
import Input from '../../../../components/Input';

const ResolveProblemPopup = ({
    open,
    setOpen,
    employeeProblem,
    customerProblem,
    bookingId
}) => {
    const dispatch = useDispatch();
    const lang = useSelector((state) => state.locale.lang);
    const bookingProblemResolutions = useSelector((state) => state.bookings.bookingProblemReslotions);
    const { bookings, shared} = messages[lang];
    const [bookingProblemResolutionsList, setBookingProblemResolutionsList] = useState([]);

    const {values,
        handleSubmit,
        setFieldTouched,
        setFieldValue,
        setTouched,
        touched, 
        errors,
        isValid,
        dirty
        
        } = useFormik({
            initialValues:{
                problemResolution: "",
            },
            validationSchema: Yup.object({
                problemResolution: Yup.string().required('required'),
                customerPaidAmount: Yup.number().when('problemResolution',{
                    is:problemResolution => problemResolution != "customer_has_paid_cash" ,
                    then:Yup.number().typeError('numbersOnly').required('required').test(
                        "is-decimal",
                        "positiveTwoDecimalOnly",
                        (val) => {
                             if (val != undefined) {
                                 return POSITIVE_TWO_DICIMAL_ONLY.test(val);
                             }
                             return true;
                         }),
                }),
                resolutionAmount: Yup.number().when('problemResolution',{
                    is:problemResolution => problemResolution != "customer_has_paid_cash" ,
                    then:Yup.number().typeError('numbersOnly').required('required').test(
                        "is-decimal",
                        "zeroOrPositiveTwoDecimalOnly",
                        (val) => {
                             if (val != undefined) {
                                 return POSITIVE_TWO_DICIMAL_ONLY.test(val);
                             }
                             return true;
                         }),
                }),
            }),
            onSubmit: async ({problemResolution, resolutionAmount, customerPaidAmount}) => {
                const buildPaymentTransactionParams = (resolutionKey, amount, paidAmount) => {
                    const baseParams = {
                        payment_transaction_attributes: {
                            appointment_problem_resolution_key: resolutionKey
                        }
                    };

                    // Only add amount fields for non-cash resolutions
                    if (resolutionKey !== 'customer_has_paid_cash') {
                        baseParams.payment_transaction_attributes.resolution_amount = amount;
                        baseParams.payment_transaction_attributes.paid_amount = +paidAmount;
                    }

                    return baseParams;
                };

                const getResolutionAmount = (resolutionType, amount) => {
                    switch (resolutionType) {
                        case 'provider_pays_mimar':
                            return +amount; // Positive
                        case 'mimar_pays_the_provider':
                            return -amount; // Negative
                        default:
                            return +amount; // Positive (default)
                    }
                };

                const calculatedResolutionAmount = getResolutionAmount(problemResolution, resolutionAmount);
                const params = buildPaymentTransactionParams(problemResolution, calculatedResolutionAmount, customerPaidAmount);
                dispatch(updateBookingRequest({
                    data:{
                        id: bookingId,
                        params: params
                    },
                    requestType:"resloved"
                }))
                dispatch(getRequestStatus(false));
                handleCloseResolveProblemPopup();
            }       
     });

    useEffect(()=>{
        const problemResolutions = bookingProblemResolutions?.map(problemResolution => {
            return {
                id: problemResolution.id,
                label: <div className="fsize-18 fweight-400 text-gray"> 
                            {problemResolution.problem_resolution}
                        </div>,
                value: problemResolution.key
            }
        })
        setBookingProblemResolutionsList([...problemResolutions]);
    },[lang, bookingProblemResolutions]);

    useEffect(()=>{
       if(values['problemResolution'] === "provider_pays_mimar" || values['problemResolution'] === "mimar_pays_the_provider"){
        setFieldValue("resolutionAmount",'');
        setFieldValue("customerPaidAmount", '');
        setTouched({}, false);
       }
        
    },[values['problemResolution']])

    const handleCloseResolveProblemPopup = () => {
        setOpen(false);
        setFieldValue("problemResolution", '');
        setFieldValue("resolutionAmount", '');
        setFieldValue("customerPaidAmount", '');
        setTouched({}, false);

    };
    const renderResolveProblemPopupContent = () => (
        <div>
            <div className="mb-3 fsize-20 fweight-400 text-secondary">
                {customerProblem
                    ? <div> {bookings.details.Customer}: {customerProblem}</div>
                    : ''
                }
                {employeeProblem
                    ? <div> {bookings.details.Employee}: {employeeProblem}</div>
                    : ''
                }
            </div>
            <div className="fsize-20 fweight-400 mb-2">{bookings.details.selectAction}*</div>
            <RadioButtonsGroup
                name="problemResolution"
                labelId="problemResolution"
                list={bookingProblemResolutionsList}
                onChange={(e) => {
                    setFieldTouched("problemResolution");
                    setFieldValue("problemResolution", e.target.value);
                  }}
            />
            {(values['problemResolution'] === "provider_pays_mimar" || 
              values['problemResolution'] === "mimar_pays_the_provider") && (
                <div className="mt-2">
                    <Input
                        id="customerPaidAmount"
                        name="customerPaidAmount"
                        type="text"
                        label={bookings.details.customerPaidAmount.label}
                        required
                        placeholder={bookings.details.customerPaidAmount.placeholder}
                        inputWrapperClass="mb-3"
                        value={values["customerPaidAmount"]}
                        onChange={(value) => {
                            setFieldTouched("customerPaidAmount");
                            setFieldValue("customerPaidAmount", value);
                        }}
                        isInputHasErr={!!(touched["customerPaidAmount"] && errors["customerPaidAmount"])}
                        errMsg={errors["customerPaidAmount"]}
                    />
                    <Input
                        id="resolutionAmount"
                        name="customerParesolutionAmountidAmount"
                        type="text"
                        label={bookings.details.resolutionAmount.label}
                        required
                        placeholder={bookings.details.resolutionAmount.placeholder}
                        inputWrapperClass="mb-3"
                        value={values["resolutionAmount"]}
                        onChange={(value) => {
                            setFieldTouched("resolutionAmount");
                            setFieldValue("resolutionAmount", value);
                        }}
                        isInputHasErr={!!(touched["resolutionAmount"] && errors["resolutionAmount"])}
                        errMsg={errors["resolutionAmount"]}
                    />

                </div>
            )}
        </div>

    );

    return(
        <Modal
                open={open}
                handleClose={handleCloseResolveProblemPopup}
                title={<span className="fsize-26 fweight-400">{bookings.details.resolveProblem}</span>}
                contentClass="mb-3 pb-2 text-primary"
                content={renderResolveProblemPopupContent()}
                confirmBtnTxt={bookings.details.setAppointmentAsCompleted}
                cancelBtnTxt={shared.cancel}
                isContentText={false}
                handleConfirm={handleSubmit}
                handleCancel={handleCloseResolveProblemPopup}
                maxWidth="sm"
                actionsClass=" px-4"
                confirmBtnClass="btn-secondary fsize-14 text-white py-2 px-5"
                cancelBtnClass="fsize-14 py-2 text-secondary px-5 "
                disableActionBtn={!isValid || !dirty}
            />
    )
}

export default ResolveProblemPopup;